// import { useState } from "react";
import React, {
  useState,
  Fragment,
  useRef,
  useEffect,
} from 'react';
import Fade from 'react-reveal/Fade';

import Respond from './Respond';

const Options = (props) => {
  const { options } = props;
  const [id, setId] = useState(0);
  const [showBot, toggleBot] = useState(false);
  const messageEndRef = useRef(null);

  useEffect(() => {
    messageEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [options])

  return (
    <div className="options">
      <div className="options-container">
        {options.map((option, index) => {
          return (
            <Fragment key={index}>
              {
                option.isOtherSource === true && option.url !== '' ? (
                  <a
                    className="option-item"
                    href={option.url}
                    key={option.id}
                    name="link"
                    aria-label="link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {option.name}
                  </a>
                ) : (
                  <div
                    aria-hidden="true"
                    className="option-item"
                    onClick={
                      () => {
                        setId(option.id);
                        toggleBot(true);
                      }
                    }
                    key={option.id}
                  >
                    {option.name}
                  </div>
                )
              }

            </Fragment>
          );
        })}
        {
          showBot && (
            <Fade big>
              <div id="showbot">
                <Respond id={id} />
              </div>
            </Fade>
          )
        }

        <div ref={messageEndRef} />

      </div>
    </div>
  );
};

export default Options;
